import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { defaultLocale } from '../config/i18n.config';
import { LocaleProvider } from '../context/localeContext';
import BlogRollPaginated from '../components/BlogRollPaginated';
import Hero from '../components/Hero';
import Section from '../components/Section';
import Layout from '../components/Layout';
import { MarkdownContent } from '../components/Content';

const OurWorkPageTemplate = ({ data, pageContext }) => {
  const { frontmatter: page } = data.markdownRemark;
  const researchPublications = data.researchPublications.edges;
  const policyPosts = [];
  const blogPosts = data.blogPosts.edges;
  for(const blogPost of blogPosts) {
    if(blogPost.node.frontmatter.tags?.find((tag) => tag == "Policy"))
      policyPosts.push(blogPost);
  }

  return (
    <LocaleProvider locale={pageContext.locale}>
      <Layout>
        <>
          <Hero image={page[defaultLocale].image} />

          <Section colorScheme="black">
            <div className="container flex flex-col md:flex-row py-12 gap-x-12 text-base">
              <div className="pb-4 md:w-1/3">
                <h2>
                  <span className="bg-theme-underline">{page[defaultLocale].title}</span>
                </h2>
              </div>
              <div className="md:w-2/3 text-base">
                <MarkdownContent content={page[defaultLocale].hero} />
              </div>
            </div>
          </Section>

          <Section colorScheme="white">
            <div class="container py-12">
              <div class="content text-base xl:px-36 2xl:px-64">
                <MarkdownContent content={page[defaultLocale].section1} />
              </div>
            </div>
          </Section>

          <BlogRollPaginated
            items={researchPublications}
            pageSize={3}
            isCompact={true}
          />

          <Section colorScheme="white">
            <div class="container py-12">
              <div class="content text-base xl:px-36 2xl:px-64">
                <MarkdownContent content={page[defaultLocale].section2} />
              </div>
            </div>
          </Section>

          <BlogRollPaginated
            items={policyPosts}
            pageSize={3}
            isCompact={true}
          />
        </>

      </Layout>
    </LocaleProvider>
  );
};

OurWorkPageTemplate.propTypes = {
  data: PropTypes.object.isRequired,
};

export default OurWorkPageTemplate;

export const query = graphql`
  query OurWorkPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        en {
          title
          hero
          body
          tags
          section1
          section2
          image {
            childImageSharp {
              gatsbyImageData(quality: 100, layout: FULL_WIDTH)
            }
          }
        }
        de {
          title
          hero
          body
          tags
          section1
          section2
          image {
            childImageSharp {
              gatsbyImageData(quality: 100, layout: FULL_WIDTH)
            }
          }
        }
      }
    }
    researchPublications: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: {
        fields: {
          collection: { eq: "research-publications" }
        }
        frontmatter: { title: { ne: "" } }
        rawMarkdownBody: { ne: "" }
      }
      limit: 3
    ) {
      edges {
        node {
          ...BlogRollItem
        }
      }
    }
    blogPosts: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: {
        fields: { collection: { eq: "blog-posts" } }
        frontmatter: { title: { ne: "" } }
        rawMarkdownBody: { ne: "" }
      }
    ) {
      edges {
        node {
          ...BlogRollItem
        }
      }
    }
  }
`;
